import { render, staticRenderFns } from "./IcoStem.vue?vue&type=template&id=74ab64c8"
import script from "./IcoStem.vue?vue&type=script&lang=js"
export * from "./IcoStem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports